export default function formatCurrency(
  amount: number | null | undefined,
  currency?: string | null
) {
  let value = amount || 0;
  let defaultCurrency = currency ?? 'EUR';

  return new Intl.NumberFormat('fi-Fi', {
    style: 'currency',
    currency: defaultCurrency,
  }).format(value);
}
